import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import zipObject from 'lodash/zipObject';
import useExpandLogic from "./useExpandLogic";
var useExpanderHandler = function useExpanderHandler() {
  var _useExpandLogic = useExpandLogic(),
    _handleExpand = _useExpandLogic.handleExpand,
    expandedItems = _useExpandLogic.expandedItems;
  var _useExpandLogic2 = useExpandLogic(),
    handleAnimationExpand = _useExpandLogic2.handleExpand,
    expandedAnimationLines = _useExpandLogic2.expandedItems;
  return {
    handleAnimationExpand: function handleAnimationExpand(item) {
      _handleExpand(item);
    },
    handleExpand: function handleExpand(item) {
      var result = handleAnimationExpand(item);
      if (!result) {
        _handleExpand(item);
      }
    },
    expandedLines: zipObject(expandedItems, _toConsumableArray(expandedItems.map(function () {
      return true;
    }))),
    expandedAnimationLines: zipObject(expandedAnimationLines, _toConsumableArray(expandedAnimationLines.map(function () {
      return true;
    })))
  };
};
export default useExpanderHandler;